import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import resumeAPI from '../services/api';
import PortfolioFeatureDemo from '../components/PortfolioFeatureDemo';

const PortfolioExamplePage = () => {
  const { isAuthenticated } = useAuth();
  const [primaryResume, setPrimaryResume] = useState(null);

  useEffect(() => {
    const loadResume = async () => {
      try {
        const data = await resumeAPI.fetchPrimary();
        if (data && data.length > 0) {
          setPrimaryResume(data[0]);
        }
      } catch (err) {
        console.error('Failed to load primary resume for example page:', err);
      }
    };
    loadResume();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-custom py-8">
        {/* Back Navigation */}
        <div className="mb-6">
          <Link
            to="/portfolio"
            className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to My Portfolio
          </Link>
        </div>

        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Example Portfolio Showcase</h1>
          <p className="text-gray-600">
            See how a professional portfolio looks when built with Career Branding Network. Use this as inspiration for your own portfolio.
          </p>
        </div>

        {/* Demo Component */}
        <PortfolioFeatureDemo
          aboutText={primaryResume?.summary || ''}
          subtitle={primaryResume?.target_role || primaryResume?.title || ''}
          footerText={primaryResume?.target_role || primaryResume?.title || ''}
          hideAboutSection={false}
        />
      </div>
    </div>
  );
};

export default PortfolioExamplePage;
